import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const KEY = "tilesmate_customs_token";
export const getCustomsToken = () => localStorage.getItem(KEY);
export const setCustomsToken = (t) => { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); };

const customsClient = axios.create({ baseURL: API });
customsClient.interceptors.request.use((cfg) => {
  const t = getCustomsToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  cfg.headers["X-App-Origin"] = window.location.origin;
  return cfg;
});

export default customsClient;
